import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  inject,
} from '@angular/core';

@Component({
  selector: 'lyceo-segment-button',
  templateUrl: './segment-button.component.html',
  styleUrl: './segment-button.component.scss',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentButtonComponent {
  public readonly elRef: ElementRef = inject(ElementRef);

  public readonly value: InputSignal<unknown> = input();
  public readonly selected: OutputEmitterRef<SegmentButtonComponent> = output();

  public get x(): number {
    return this.elRef.nativeElement.offsetLeft;
  }

  public get width(): number {
    return this.elRef.nativeElement.clientWidth;
  }

  protected onClick(): void {
    this.selected.emit(this);
  }
}
